import { Header } from "./Header";
import Home from "./Home";
import Second from "./Second";
import ThirdPage from "./Thirdpage";
import { LastPage } from "./Lastpage";
import { TableData } from "./Table";
import { Secure } from "./Secure";
import { Footer } from "./Footer";
// import Tmp from './Tmp';

function Main() {
  return (
    <div className="Home">
      <Header />
      <Home />
      <Second />
      <ThirdPage />
      <TableData />
      <Secure />
      <LastPage />
      <Footer />
    </div>
  );
}

export default Main;
